import { post } from 'common/axiosClient';
import { handleError } from '../../common/utils/util.errors';
import { LineItemWithDivision } from '../glossary/glossary.type';
import { API } from '../../common/constants/urls';

export const findDivisionsByDescriptions = async (descriptions: string[]): Promise<LineItemWithDivision[]> => {
  try {
    const response = await post(`${API.LINE_ITEMS}/find-divisions`, descriptions);
    return response;
  } catch (error) {
    handleError(error);
    return [];
  }
};
